import VChartsLoader from './lib/vcharts_loader.js';
import { intersectionObserverLazyLoad, setupStoragePriceModal, setupBandwidthPriceModal } from './global';
import { initializePopovers, Popover } from './lib/bootstrap_components';

class HyperscalersPage {
  constructor() {
    this.vchartsLoader = new VChartsLoader();
    this.clusterPriceUpdateTimer = null;
  }

  init() {
    this.vchartsLoader.init();
    this.setupLazyLoadCharts();
    this.setupClusterPriceForm();
    this.init_pricing_details_popover()
    this.setupHosterFilters();
    setupStoragePriceModal();
    setupBandwidthPriceModal();
  }

  setupLazyLoadCharts() {
    intersectionObserverLazyLoad("lazy-chart.chart-canvas", "300px", (container) => {
      this.load_metrics_chart(`#${container.id}`);
    });
    intersectionObserverLazyLoad("cost-charts-list", "300px", (container) => {
      const selectedPlanIds = this.selectedPlanIdsInClusterForm();
      this.refreshCostCharts(selectedPlanIds);
    });
    intersectionObserverLazyLoad("simple-cost-charts-list", "300px", (container) => {
      this.load_all_cost_pie_charts();
    });
    intersectionObserverLazyLoad("lazy-chart.total-prices-chart-canvas", "300px", (container) => {
      this.load_total_prices_chart(`#${container.id}`);
    });
  }

  init_pricing_details_popover() {
    const selector = '[data-bs-toggle="popover"]';
    const $triggers = $(selector);
    initializePopovers(selector, {
      html: true,
      trigger: 'click',
      delay: { show: 0, hide: 0 },
    });

    $triggers.each(function() {
      const trigger = this;
      trigger.addEventListener('show.bs.popover', () => {
        $triggers.each(function() {
          if (this !== trigger) Popover.getOrCreateInstance(this).hide();
        });
      });

      trigger.addEventListener('inserted.bs.popover', () => {
        const dismiss = (event) => {
          if (!$(event.target).closest(`${selector}, .popover`).length) {
            $triggers.each(function() {
              Popover.getOrCreateInstance(this).hide();
            });
            $(document).off('click.popover-dismiss', dismiss);
          }
        };

        $(document).on('click.popover-dismiss', dismiss);
      });
    });
  }

  setupHosterFilters() {
    $('.hoster-checkbox').on('change', function() {
      const hosterId = $(this).closest('[data-hoster-id]').data('hoster-id');
      const checked = $(this).is(':checked');
      $(`[data-hoster-id="${hosterId}"]:not(.overview-hoster-card)`).toggle(checked);
    });
  }

  load_metrics_chart(canvasId) {
    var canvas = $(canvasId);
    if (canvas.length == 0) {
      console.error(canvasId + " is missing from hyperscalers page");
      return;
    }

    var ctx = canvas.get(0).getContext("2d");
    var metrics = canvas.data('metrics');
    var trial_ids = $("span#trials-data").data("trial-ids");
    $.ajax({
      type: 'GET',
      url: `/hyperscalers/metrics_chart_data/${metrics}`,
      data: { trial_ids: trial_ids },
      dataType: 'json',
      success: (data) => {
        console.log("success hyperscalers metrics charts_data");
        this.vchartsLoader.simple_chart(ctx, 'bar', data, { horizontal: true });
      }
    })
  }

  load_total_prices_chart(canvasId) {
    var canvas = $(canvasId);
    if (canvas.length == 0) {
      console.error(canvasId + " is missing from hypercalers page");
      return;
    }

    var ctx = canvas.get(0).getContext("2d");
    var legend = canvas.data('legend');

    const form = $('#cluster-price-form');
    const formData = new FormData(form[0]);

    $.ajax({
      type: 'PUT',
      url: `/hyperscalers/total_prices_chart_data`,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
      success: (data) => {
        console.log("success hyperscalers total prices charts_data");
        this.vchartsLoader.simple_chart(ctx, 'bar', data, { legend_title: legend, horizontal: true });
      }
    })
  }

  load_all_cost_pie_charts(canvasId = null) {
    let canvases;
    if (canvasId) {
      canvases = $(canvasId);
    } else {
      canvases = $('.cost-chart-canvas');
    }

    if (canvases.length === 0) {
      if (canvasId) console.error(canvasId + " is missing from hyperscalers page");
      return;
    }

    const planIds = [];
    const trialIds = [];
    // Map to store canvas context and legend by "item-id" key (e.g., "plan-123" or "trial-456")
    const canvasContexts = {};

    canvases.each((_index, element) => {
      const $canvas = $(element);
      const currentCanvasId = `#${$canvas.attr('id')}`;
      const trial_id = $canvas.data('trial-id');
      const plan_id = $canvas.data('plan-id');
      const legend = $canvas.data('legend');
      const ctx = $canvas.get(0).getContext("2d");

      if (plan_id) {
        planIds.push(plan_id);
        canvasContexts[`plan-${plan_id}`] = { ctx, legend };
      } else if (trial_id) {
        trialIds.push(trial_id);
        canvasContexts[`trial-${trial_id}`] = { ctx, legend };
      } else {
        console.error(`No trial_id or plan_id found for cost pie chart: ${currentCanvasId}`);
      }
    });

    const form = $('#cluster-price-form');
    const formData = new FormData(form[0]);
    const baseData = {};
    for (let [key, value] of formData.entries()) {
      if (key.endsWith('[]')) { // Handle array-like parameters
        key = key.slice(0, -2); // Remove '[]' from the key
        if (!baseData[key]) {
          baseData[key] = [];
        }
        baseData[key].push(value);
      } else {
        baseData[key] = value;
      }
    }

    const makeAjaxCall = (itemType, ids) => {
      if (ids.length === 0) return;

      $.ajax({
        url: `/hyperscalers/cost_chart_data/${itemType}`,
        method: 'PUT',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
          ...baseData,
          item_ids: ids.join(',')
        },
        dataType: 'json',
        success: (data) => {
          console.log(`success hyperscalers cost charts_data for ${itemType}`);
          for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              const chartData = data[key];
              const { ctx, legend } = canvasContexts[key];
              if (ctx && chartData) {
                this.vchartsLoader.simple_pie_chart(ctx, chartData, { legend_title: legend });
              }
            }
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error(`Error loading cost pie charts for ${itemType}:`, textStatus, errorThrown);
        }
      });
    };

    makeAjaxCall('plan', planIds);
    makeAjaxCall('trial', trialIds);
  }

  load_cost_pie_chart(canvasId) {
    this.load_all_cost_pie_charts(canvasId);
  }

  setupClusterPriceForm() {
    const form = $('#cluster-price-form');
    if (form.length === 0) return;

    const plansSelect = $('#selectize-plans-select');
    if (plansSelect.length > 0) {
      if (plansSelect.siblings('.selectize-control').length > 0) {
        plansSelect.siblings('.selectize-control').remove();
      }

      plansSelect.selectize({
        plugins: ['remove_button'],
      });
    }

    form.off('submit');

    form.on('input', 'input[type="number"]', () => {
      clearTimeout(this.clusterPriceUpdateTimer);
      this.clusterPriceUpdateTimer = setTimeout(() => {
        this.updateClusterPrice(form[0]);
      }, 500);
    });

    form.on('change', 'select', () => {
      clearTimeout(this.clusterPriceUpdateTimer);
      this.clusterPriceUpdateTimer = setTimeout(() => {
        this.updateClusterPrice(form[0]);
      }, 500);
    });

    form.on('input', 'input[type="checkbox"]', () => {
      this.updateClusterPrice(form[0]);
    });

    form.on('click', '[data-cluster-price-core-shortcut]', event => {
      event.preventDefault();

      const nextNumCores = parseInt($(event.currentTarget).data('cluster-price-core-shortcut'), 10);
      const currentNumCores = parseInt(form.find('#cluster-price-num-cores').val(), 10);
      if (nextNumCores === currentNumCores) return;

      form.find('#cluster-price-num-cores').val(nextNumCores);
      this.updateClusterPrice(form[0], { refreshForm: true, resetPlanSelection: true });
    });
  }

  selectedPlanIdsInClusterForm() {
    const form = $('#cluster-price-form');
    const formData = new FormData(form[0]);
    const selectedPlanIds = [];
    for (let [key, value] of formData.entries()) {
      if (key === 'usage_specs[plan_ids][]') {
        selectedPlanIds.push(parseInt(value, 10));
      }
    }
    return selectedPlanIds;
  }

  updateClusterPrice(form, options = {}) {
    const formData = new FormData(form);
    const resultsContainer = $('#cluster-price-results');
    resultsContainer.html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>');

    if (options.resetPlanSelection) {
      formData.delete('usage_specs[plan_ids][]');
    }

    if (options.refreshForm) {
      formData.append('refresh_form', '1');
    }

    $.ajax({
      url: form.action,
      method: 'PUT',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: formData,
      processData: false,
      contentType: false,
      dataType: options.refreshForm ? 'json' : 'html'
    })
    .done(response => {
      if (options.refreshForm) {
        $('#cluster-price-form-container').html(response.form_html);
        this.setupClusterPriceForm();
        resultsContainer.html(response.results_html);
      } else {
        resultsContainer.html(response);
      }

      this.init_pricing_details_popover();
      this.refreshCharts(this.selectedPlanIdsInClusterForm());
    })
    .fail((jqXHR, textStatus, error) => {
      console.error('Error updating cluster price:', error);
      resultsContainer.html('<p class="text-danger">Error calculating price. Please try again.</p>');
    });
  }

  refreshCharts(planIds) {
    $('.total-prices-chart-canvas').each((_index, element) => {
      this.load_total_prices_chart(`#${element.id}`);
    });

    this.refreshCostCharts(planIds);
  }

  refreshCostCharts(planIds) {
    console.debug("Refreshing cost charts for plan IDs:", planIds);
    const chartsWrapper = $('#cost-charts-list');
    if (chartsWrapper.length === 0) {
      console.error("Cost charts wrapper #cost-charts-list is missing.");
      return;
    }

    chartsWrapper.html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>');

    $.ajax({
      url: '/hyperscalers/render_cost_charts',
      method: 'GET',
      data: { plan_ids: planIds.join(',') },
      dataType: 'html',
      success: (html) => {
        chartsWrapper.html(html);
        this.load_all_cost_pie_charts();
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.error('Error refreshing cost charts:', textStatus, errorThrown);
        chartsWrapper.html('<p class="text-danger">Error loading cost charts. Please try again.</p>');
      }
    });
  }
}

$(document).on('turbo:load', function() {
  if ($("body.hyperscalers.simple_use_case, body.hyperscalers.cluster_price, body.hyperscalers.providers").length > 0) {
    var hyperscalers_page = new HyperscalersPage();
    hyperscalers_page.init();
  }
});
